import LoadStyleTypes from './load-style.types';

export const changeStyle = currentStyle => ({
    type: LoadStyleTypes.CHANGE_STYLE,
    payload: currentStyle
});

export default changeStyle;